export enum FeatureToggle {
  connectedStores = 'rt_connected_stores',
  notOnFile = 'rt_connected_stores_caper_not_on_file',
  inventoryIntelligence = 'rt_connected_stores_inventory_intelligence',
  staffBarcodeManagement = 'rt_caper_staff_barcode_management',
  staffBarcodeManagementRetailer = 'rt_caper_staff_barcode_management_retailer',
  progressiveEntityLoading = 'rt_csc_progressive_entity_loading',
  caperDisableAuthorEmail = 'rt_caper_disable_author_email',
}
